<template>
  <div>
    <v-card flat>
      <v-card-title>
        <label class="primary--text px-5 font-weight-bold info-page-title ma-auto">{{ $t(`label.contactUs`) }}</label>
      </v-card-title>
    </v-card>

    <v-card class="info-page-card">
      <v-expansion-panels accordion v-model="panel">
        <v-expansion-panel v-for="info in aboutUsContent" :key="info.title">
          <v-expansion-panel-header class="font-weight-bold text-uppercase">{{ info.title }}</v-expansion-panel-header>
          <v-expansion-panel-content class="py-4 info-expension-panel-content">
            <div v-for="content in info.content" :key="content.title">
              <p class="text-capitalize font-weight-bold info-expension-panel-content-title mb-1" v-html="content.title"></p>
              <p v-html="content.desc"></p>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
  </div>
</template>
<script>
import { locale, uiHelper } from '@/util'
export default {
  name: 'aboutUs',
  data: () => ({
    panel: 0,
    aboutUsContent: [
      {
        title: locale.getMessage(`info.info_contactUs`),
        content: [
          {
            title: locale.getMessage(`info.info_contactUs_a_title`),
            desc: locale.getMessage(`info.info_contactUs_a_desc`)
          },
          {
            title: locale.getMessage(`info.info_contactUs_b_title`),
            desc: locale.getMessage(`info.info_contactUs_b_desc`)
          },
          {
            title: locale.getMessage(`info.info_contactUs_c_title`),
            desc: locale.getMessage(`info.info_contactUs_c_desc`)
          }
        ]
      }
    ]
  }),
  created() {
    this.metaTag()
  },
  methods: {
    metaTag() {
      uiHelper.setCanonical('/info/contact-us/')
      const isBestDomain = window.location.hostname.includes('jaya9.best')
      const isCashDomain = window.location.hostname.includes('jaya9.cash')

      if (isBestDomain) {
        uiHelper.setTitle(`${locale.getMessage('meta.contactUs_title_best')}`)
        uiHelper.setMetaTag('description', `${locale.getMessage('meta.contactUs_description_best')}`)
        uiHelper.setMetaTagProp('og:title', `${locale.getMessage('meta.contactUs_title_best')}`)
        uiHelper.setMetaTagProp('og:description', `${locale.getMessage('meta.contactUs_description_best')}`)
      } else if (isCashDomain) {
        uiHelper.setTitle(`${locale.getMessage('meta.contactUs_title_cash')}`)
        uiHelper.setMetaTag('description', `${locale.getMessage('meta.contactUs_description_cash')}`)
        uiHelper.setMetaTagProp('og:title', `${locale.getMessage('meta.contactUs_title_cash')}`)
        uiHelper.setMetaTagProp('og:description', `${locale.getMessage('meta.contactUs_description_cash')}`)
      } else {
        uiHelper.setTitle(`${locale.getMessage('meta.contactUs_title')}`)
        uiHelper.setMetaTag('description', `${locale.getMessage('meta.contactUs_description')}`)
        uiHelper.setMetaTagProp('og:title', `${locale.getMessage('meta.contactUs_title')}`)
        uiHelper.setMetaTagProp('og:description', `${locale.getMessage('meta.contactUs_description')}`)
      }
    }
  }
}
</script>
